(() => {
  const moneyFallback = (cents, currency='MYR') => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  const formatShopMoney = (cents) => {
    const format = window.PNE_MONEY_FORMAT || 'RM {{amount}}';
    const value = (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/{{\s*amount(?:_with_comma_separator|_no_decimals|_no_decimals_with_comma_separator)?\s*}}/, value);
  };

  const bucksReconvert = () => { try { ((window || {}).bucksCC || {}).reConvert && window.bucksCC.reConvert(); } catch(e) {} };

  const I18N = window.PNE_I18N || {};
  const tr = (key, fallback='') => I18N[key] || fallback;

  const q = (s, c=document) => c.querySelector(s);
  const qa = (s, c=document) => [...c.querySelectorAll(s)];

  // Mobile nav
  qa('[data-menu-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    const open = nav.hasAttribute('hidden');
    nav.toggleAttribute('hidden', !open);
    btn.setAttribute('aria-expanded', String(open));
  }));

  // Cart drawer
  const drawer = q('#PneCartDrawer');
  let cartCurrency = 'MYR';
  const formatCartMoney = (cents) => { try { return moneyFallback(cents, cartCurrency); } catch(e) { return formatShopMoney(cents); } };
  async function refreshCart(open=true) {
    if (!drawer) return;
    try {
      const cart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
      cartCurrency = cart.currency || cartCurrency;
      qa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      const body=q('[data-cart-items]',drawer), subtotal=q('[data-cart-subtotal]',drawer);
      if (subtotal) { subtotal.innerHTML=formatShopMoney(cart.total_price); }
      if (body) {
        body.innerHTML = cart.items.length ? cart.items.map((item,index)=>`
          <div class="pne-drawer-line">
            ${item.image ? `<img src="${item.image}" alt="">` : ''}
            <div><a href="${item.url}">${item.product_title}</a><small>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</small>${formatShopMoney(item.final_line_price)}</div>
            <div class="pne-drawer-qty"><button type="button" data-cart-change="${index+1}" data-qty="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index+1}" data-qty="${item.quantity+1}">+</button></div>
          </div>`).join('') : `<p class="pne-muted">${tr('emptyBag','Your collector bag is empty.')}</p>`;
      }
      bucksReconvert();
      if (open) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('pne-no-scroll'); }
    } catch(e) { console.warn('PNE cart refresh failed', e); }
  }
  qa('[data-cart-open]').forEach(btn=>btn.addEventListener('click',()=>refreshCart(true)));
  qa('[data-cart-close]').forEach(btn=>btn.addEventListener('click',()=>{ if(!drawer)return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('pne-no-scroll'); }));
  drawer?.addEventListener('click', async e => {
    const btn=e.target.closest('[data-cart-change]'); if(!btn)return;
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(btn.dataset.cartChange),quantity:Number(btn.dataset.qty)})});
    refreshCart(true);
  });

  // Home vault hero
  qa('[data-vault-hero]').forEach(root => {
    const stage=q('[data-vault-stage]',root), gallery=q('[data-vault-gallery]',root), images=qa('[data-vault-image]',root);
    const cta=q('[data-vault-cta]',root), price=q('[data-vault-price]',root), title=q('[data-vault-title]',root), code=q('[data-vault-code]',root), route=q('[data-vault-route]',root);
    let selectedUrl = cta?.getAttribute('href') || '#';
    qa('[data-vault-edition]',root).forEach(btn => btn.addEventListener('click',()=>{
      qa('[data-vault-edition]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      images.forEach(img=>img.classList.toggle('is-active',img.dataset.vaultImage===btn.dataset.vaultEdition));
      root.classList.toggle('pne-accent-blue',btn.dataset.accent==='blue');
      if (title) title.textContent=btn.dataset.title;
      if (code) code.textContent=btn.dataset.code;
      if (price) { price.innerHTML=formatShopMoney(Number(btn.dataset.priceCents || 0)); price.classList.remove('pne-price-in'); void price.offsetWidth; price.classList.add('pne-price-in'); }
      selectedUrl=btn.dataset.url; bucksReconvert();
      if (cta && !cta.dataset.quoteMode) cta.href=selectedUrl;
    }));
    qa('[data-vault-region]',root).forEach(btn=>btn.addEventListener('click',()=>{
      qa('[data-vault-region]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      const quote=btn.dataset.vaultRegion==='quote';
      if(route) route.textContent=quote?`${tr('europeOther','Other')} · ${tr('quoteRequired','Quote required')}`:`${btn.dataset.regionLabel || (btn.textContent.trim().startsWith('U.S.')?tr('us','U.S.'):tr('asia','Asia'))} · ${tr('directCheckout','Direct checkout')}`;
      if(cta){
        if(quote){cta.dataset.quoteMode='1';cta.textContent=tr('requestQuote',document.documentElement.dataset.quoteLabel || 'Request Shipping Quote');cta.classList.add('pne-btn--outline');cta.classList.remove('pne-btn--gold');cta.href=window.PNE_QUOTE_URL || '#';}
        else{delete cta.dataset.quoteMode;cta.textContent=tr('viewSelectedEdition','View Selected Edition');cta.classList.add('pne-btn--gold');cta.classList.remove('pne-btn--outline');cta.href=selectedUrl;}
      }
    }));
    qa('[data-vault-view]',root).forEach((btn,i)=>btn.addEventListener('click',()=>{
      qa('[data-vault-view]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      const img=q('.pne-stage__image.is-active',root); if(!img)return;
      img.style.transform=`scale(${1+i*.014}) translateX(${i===1?-1.1:i===2?1.1:0}%)`; setTimeout(()=>img.style.transform='',430);
    }));
    if(stage && gallery && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      stage.addEventListener('mousemove',e=>{const r=stage.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;gallery.style.transform=`rotateX(${(y-.5)*-2.4}deg) rotateY(${(x-.5)*3.5}deg) scale(1.005)`;stage.style.setProperty('--mx',`${x*100}%`);stage.style.setProperty('--my',`${y*100}%`)});
      stage.addEventListener('mouseleave',()=>gallery.style.transform='');
    }
  });

  // Product page
  const initProductSection = (root) => {
    if (!root || root.dataset.pneProductInitialized === 'true') return;
    root.dataset.pneProductInitialized = 'true';

    const form=q('.pne-product-form',root), variantInput=q('[data-product-variant-id]',root), addBtn=q('[data-product-add]',root), price=q('[data-product-price]',root), code=q('[data-product-code]',root), stage=q('[data-product-stage]',root), gallery=q('[data-product-gallery]',root), quoteBtn=q('[data-product-quote]',root), filmstrip=q('[data-media-filmstrip]',root), counter=q('[data-media-counter]',root);
    const productJson=q('[data-product-json]',root);
    const variants=productJson ? JSON.parse(productJson.textContent) : [];

    const getMedia = () => qa('.pne-product-media',root).filter(m=>m.dataset.mediaId);
    const getThumbs = () => qa('[data-product-thumb]',root);
    const warmedGallerySrcs = new Set();
    const warmMedia = (item) => {
      if(!item) return;
      const src=item.dataset.galleryPreloadSrc;
      if(!src || warmedGallerySrcs.has(src)) return;
      warmedGallerySrcs.add(src);
      const preloader=new Image();
      preloader.decoding='async';
      preloader.src=src;
    };
    const warmAdjacentMedia = (media,index) => {
      if(!media.length || index < 0) return;
      const task=()=>{
        warmMedia(media[(index+1)%media.length]);
        warmMedia(media[(index-1+media.length)%media.length]);
      };
      if('requestIdleCallback' in window) window.requestIdleCallback(task,{timeout:900});
      else window.setTimeout(task,180);
    };

    // V8: keep inactive gallery media lightweight (360px preview).
    // Promote only the selected image to the 900px gallery asset.
    const promoteGalleryImage = (item) => {
      if(!item || !item.classList.contains('pne-product-image')) return;
      const img=q('img',item);
      const src=item.dataset.galleryPreloadSrc;
      if(!img || !src || img.dataset.galleryLoaded==='true') return;
      img.dataset.galleryLoaded='true';
      img.src=src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    };

    const showMedia = (id, shouldScroll=true) => {
      const media=getMedia();
      const target=media.find(m=>String(m.dataset.mediaId)===String(id));
      if(!target) return;

      media.forEach(m=>{
        const active=m===target;
        m.classList.toggle('is-active',active);
        m.setAttribute('aria-hidden',active?'false':'true');
        if(m.classList.contains('pne-product-image')) m.tabIndex=active?0:-1;
        if(!active) qa('video',m).forEach(v=>{ try{v.pause();}catch(e){} });
      });

      const thumbs=getThumbs();
      thumbs.forEach(b=>b.classList.toggle('is-active',String(b.dataset.mediaId)===String(id)));
      const index=media.indexOf(target);
      promoteGalleryImage(target);
      warmAdjacentMedia(media,index);
      if(counter && index>=0) counter.textContent=`${String(index+1).padStart(2,'0')} / ${String(media.length).padStart(2,'0')}`;

      const activeThumb=thumbs.find(b=>String(b.dataset.mediaId)===String(id));
      if(activeThumb && filmstrip && shouldScroll){
        const left=activeThumb.offsetLeft-(filmstrip.clientWidth-activeThumb.offsetWidth)/2;
        filmstrip.scrollTo({left:Math.max(0,left),behavior:'smooth'});
      }
    };

    const initial=q('.pne-product-media.is-active',root) || getMedia()[0];
    if(initial) showMedia(initial.dataset.mediaId,false);

    getThumbs().forEach(b=>{
      const warmThumb=()=>{
        const item=getMedia().find(m=>String(m.dataset.mediaId)===String(b.dataset.mediaId));
        warmMedia(item);
      };
      b.addEventListener('pointerenter',warmThumb,{passive:true});
      b.addEventListener('focus',warmThumb,{passive:true});
      b.addEventListener('touchstart',warmThumb,{passive:true});
      b.addEventListener('click',()=>showMedia(b.dataset.mediaId));
    });

    q('[data-product-prev]',root)?.addEventListener('click',()=>{
      const media=getMedia(); if(!media.length)return;
      const current=media.findIndex(m=>m.classList.contains('is-active'));
      const next=(current<=0?media.length:current)-1;
      showMedia(media[next].dataset.mediaId);
    });
    q('[data-product-next]',root)?.addEventListener('click',()=>{
      const media=getMedia(); if(!media.length)return;
      const current=media.findIndex(m=>m.classList.contains('is-active'));
      const next=(current+1)%media.length;
      showMedia(media[next].dataset.mediaId);
    });

    qa('[data-media-scroll]',root).forEach(btn=>btn.addEventListener('click',()=>{
      if(!filmstrip)return;
      const dir=Number(btn.dataset.mediaScroll)||1;
      filmstrip.scrollBy({left:dir*filmstrip.clientWidth*.78,behavior:'smooth'});
    }));

    // Full-image viewer: show the complete Shopify image without changing
    // the Museum Grade stage layout.
    const lightbox=q('[data-product-lightbox]',root);
    const lightboxImage=lightbox ? q('[data-lightbox-image]',lightbox) : null;
    const lightboxCounter=lightbox ? q('[data-lightbox-counter]',lightbox) : null;
    const lightboxOriginal=lightbox ? q('[data-lightbox-original]',lightbox) : null;
    let lightboxIndex=0;
    let lightboxReturnFocus=null;

    const getLightboxImages=()=>qa('.pne-product-image[data-lightbox-src]',root);

    const renderLightbox=(index)=>{
      if(!lightbox || !lightboxImage) return;
      const items=getLightboxImages();
      if(!items.length) return;
      lightboxIndex=(index+items.length)%items.length;
      const item=items[lightboxIndex];
      const img=q('img',item);
      const src=item.dataset.lightboxSrc || img?.currentSrc || img?.src || '';
      const originalSrc=item.dataset.originalSrc || src;
      const alt=item.dataset.lightboxAlt || img?.alt || '';
      lightboxImage.src=src;
      lightboxImage.alt=alt;
      if(lightboxOriginal){
        lightboxOriginal.href=originalSrc || '#';
        lightboxOriginal.setAttribute('aria-label',`Open original image ${lightboxIndex+1} in a new tab`);
      }
      if(lightboxCounter) lightboxCounter.textContent=`${String(lightboxIndex+1).padStart(2,'0')} / ${String(items.length).padStart(2,'0')}`;
    };

    const openLightbox=(item)=>{
      if(!lightbox || !item) return;
      const items=getLightboxImages();
      const index=items.indexOf(item);
      lightboxReturnFocus=document.activeElement;
      renderLightbox(index>=0?index:0);
      lightbox.hidden=false;
      lightbox.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('pne-lightbox-open');
      document.body.classList.add('pne-lightbox-open');
      requestAnimationFrame(()=>lightbox.classList.add('is-open'));
      q('.pne-lightbox__tools [data-lightbox-close]',lightbox)?.focus({preventScroll:true});
    };

    const closeLightbox=()=>{
      if(!lightbox || lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('pne-lightbox-open');
      document.body.classList.remove('pne-lightbox-open');
      window.setTimeout(()=>{
        lightbox.hidden=true;
        if(lightboxImage) lightboxImage.src='';
        if(lightboxReturnFocus && typeof lightboxReturnFocus.focus==='function') lightboxReturnFocus.focus({preventScroll:true});
      },180);
    };

    getLightboxImages().forEach(item=>{
      item.addEventListener('click',e=>{
        if(e.target.closest('a,button,video,model-viewer')) return;
        openLightbox(item);
      });
      item.addEventListener('keydown',e=>{
        if(e.key==='Enter' || e.key===' '){
          e.preventDefault();
          openLightbox(item);
        }
      });
    });

    qa('[data-lightbox-close]',lightbox || root).forEach(btn=>btn.addEventListener('click',closeLightbox));
    q('[data-lightbox-prev]',lightbox || root)?.addEventListener('click',()=>renderLightbox(lightboxIndex-1));
    q('[data-lightbox-next]',lightbox || root)?.addEventListener('click',()=>renderLightbox(lightboxIndex+1));

    if(lightbox){
      lightbox.addEventListener('keydown',e=>{
        if(e.key==='Escape'){e.preventDefault();closeLightbox();}
        else if(e.key==='ArrowLeft'){e.preventDefault();renderLightbox(lightboxIndex-1);}
        else if(e.key==='ArrowRight'){e.preventDefault();renderLightbox(lightboxIndex+1);}
      });
    }

    // Linked editions are separate Shopify products. Keep the Museum Grade
    // configurator UI, but navigate to the real product page so media, price,
    // inventory, SEO and cart state always come from Shopify truth.
    qa('[data-edition-switch]',root).forEach(link=>{
      const prefetch=()=>{
        if(link.dataset.current==='true' || link.dataset.prefetched==='true') return;
        link.dataset.prefetched='true';
        const pf=document.createElement('link');
        pf.rel='prefetch'; pf.href=link.href; document.head.appendChild(pf);
      };
      link.addEventListener('mouseenter',prefetch,{once:true});
      link.addEventListener('focus',prefetch,{once:true});
      link.addEventListener('click',e=>{
        if(link.dataset.current==='true' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const target=link.href;
        qa('[data-edition-switch]',root).forEach(x=>x.classList.toggle('is-active',x===link));
        root.classList.toggle('pne-accent-blue',link.dataset.accent==='blue');
        root.classList.add('pne-edition-transition-out');
        const label=q('[data-product-status]',root);
        if(label) label.textContent=tr('switchingEdition','Switching edition…');
        window.setTimeout(()=>{ window.location.href=target; }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 390);
      });
    });

    qa('[data-option-position]',root).forEach(select=>select.addEventListener('change',()=>{
      const chosen=qa('[data-option-position]',root).map(s=>s.value);
      const variant=variants.find(v=>v.options.every((o,i)=>o===chosen[i]));
      if(!variant)return;
      if(variantInput) variantInput.value=variant.id;
      if(price) { price.innerHTML=formatShopMoney(variant.price); bucksReconvert(); }
      if(addBtn){addBtn.disabled=!variant.available;addBtn.textContent=variant.available?tr('addToBag','Add to Collector Bag'):tr('soldOut','Sold Out');}
      if(code) code.textContent=variant.sku || root.dataset.productHandle.toUpperCase();
      if(variant.featured_media) showMedia(variant.featured_media.id);
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    }));

    qa('[data-product-region]',root).forEach(btn=>btn.addEventListener('click',()=>{
      qa('[data-product-region]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      const quote=btn.dataset.productRegion==='quote', route=q('[data-product-route]',root);
      if(route) route.textContent=quote?`${tr('europeOther','Other')} · ${tr('quoteRequired','Quote required')}`:`${btn.dataset.regionLabel || (btn.textContent.trim().startsWith('U.S.')?tr('us','U.S.'):tr('asia','Asia'))} · ${tr('directCheckout','Direct checkout')}`;
      if(form) form.hidden=quote;
      if(quoteBtn) quoteBtn.hidden=!quote;
    }));

    if(form && form.dataset.ajaxCart === 'true') form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(addBtn){addBtn.disabled=true;addBtn.dataset.oldText=addBtn.textContent;addBtn.textContent=tr('adding','Adding…');}
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!res.ok) throw new Error(await res.text());
        await refreshCart(true);
      }catch(err){console.warn(err); alert(tr('unableAdd','Unable to add this item. Please review the selected configuration.'));}
      finally{if(addBtn){addBtn.disabled=false;addBtn.textContent=addBtn.dataset.oldText||tr('addToBag','Add to Collector Bag');}}
    });

    if(stage && gallery && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      stage.addEventListener('mousemove',e=>{const r=stage.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;gallery.style.transform=`rotateX(${(y-.5)*-1.25}deg) rotateY(${(x-.5)*1.8}deg) scale(1.0015)`;stage.style.setProperty('--mx',`${x*100}%`);stage.style.setProperty('--my',`${y*100}%`)});
      stage.addEventListener('mouseleave',()=>gallery.style.transform='');
    }
  };

  qa('[data-product-section]').forEach(initProductSection);
  document.addEventListener('shopify:section:load',e=>{
    const root=e.target.matches?.('[data-product-section]') ? e.target : q('[data-product-section]',e.target);
    if(root) initProductSection(root);
  });

  // Product recommendations lazy load
  qa('[data-product-recommendations]').forEach(section=>{
    if(section.innerHTML.trim()) return;
    fetch(section.dataset.url).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html'),fresh=doc.querySelector('[data-product-recommendations]');if(fresh){section.innerHTML=fresh.innerHTML;bucksReconvert();}});
  });

  // Campaign gateway collection image loops.
  // Keeps the cards visually alive without turning them into a hard-sell carousel.
  const initGatewaySliders=(scope=document)=>{
    qa('[data-gateway-slider]',scope).forEach(slider=>{
      if(slider.dataset.pneSliderReady==='true') return;
      slider.dataset.pneSliderReady='true';

      const slides=qa('[data-gateway-slide]',slider);
      if(slides.length<2) return;

      const card=slider.closest('[data-gateway-card]');
      const dots=card ? qa('[data-gateway-dot]',card) : [];
      const interval=Math.max(3000,Number(slider.dataset.interval)||4000);
      const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index=0;
      let timer=null;

      const loadSlide=(slide)=>{
        if(!slide) return;
        const img=q('img[data-gateway-src]',slide);
        if(img && !img.getAttribute('src')){
          img.setAttribute('src',img.dataset.gatewaySrc);
          img.removeAttribute('data-gateway-src');
        }
      };

      const show=(next)=>{
        index=(next+slides.length)%slides.length;
        loadSlide(slides[index]);
        loadSlide(slides[(index+1)%slides.length]);
        slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
        dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));
      };

      const stop=()=>{
        if(timer){clearInterval(timer);timer=null;}
      };
      const start=()=>{
        if(reduceMotion || timer || document.hidden) return;
        timer=setInterval(()=>show(index+1),interval);
      };

      loadSlide(slides[0]);
      loadSlide(slides[1]);
      show(0);
      start();

      if(card){
        card.addEventListener('mouseenter',stop);
        card.addEventListener('mouseleave',start);
        card.addEventListener('focusin',stop);
        card.addEventListener('focusout',()=>window.setTimeout(()=>{
          if(!card.contains(document.activeElement)) start();
        },0));
      }

      document.addEventListener('visibilitychange',()=>{
        if(document.hidden) stop(); else start();
      });
    });
  };

  initGatewaySliders();
  document.addEventListener('shopify:section:load',e=>initGatewaySliders(e.target));

  // Announcement feed: editorial notices only
  qa('[data-pne-feed]').forEach(feed=>{
    const items=qa('[data-feed-item]',feed); if(!items.length)return;
    let i=0,timer; const interval=Math.max(5000,Number(feed.dataset.interval)||10000);
    const tick=()=>{items[i].classList.remove('is-active');i=(i+1)%items.length;items[i].classList.add('is-active');};
    if(items.length>1) timer=setInterval(tick,interval);
    q('[data-feed-close]',feed)?.addEventListener('click',()=>{clearInterval(timer);feed.remove();});
  });


  // =========================================================
  // PNE Product Card Direct Purchase / Quick Buy V2
  // FAST GALLERY V8 branch.
  // =========================================================
  const quickBuyModal=q('[data-pne-quick-buy-modal]');
  let quickBuyData=null;
  let quickBuyVariant=null;
  let quickBuyRegion='asia';
  let quickBuyReturnFocus=null;

  const qbTitle=quickBuyModal?q('[data-pne-qb-title]',quickBuyModal):null;
  const qbImage=quickBuyModal?q('[data-pne-qb-image]',quickBuyModal):null;
  const qbImageEmpty=quickBuyModal?q('[data-pne-qb-image-empty]',quickBuyModal):null;
  const qbStatus=quickBuyModal?q('[data-pne-qb-status]',quickBuyModal):null;
  const qbPrice=quickBuyModal?q('[data-pne-qb-price]',quickBuyModal):null;
  const qbOptions=quickBuyModal?q('[data-pne-qb-options]',quickBuyModal):null;
  const qbQty=quickBuyModal?q('[data-pne-qb-qty]',quickBuyModal):null;
  const qbAvailability=quickBuyModal?q('[data-pne-qb-availability]',quickBuyModal):null;
  const qbCheckout=quickBuyModal?q('[data-pne-qb-checkout]',quickBuyModal):null;
  const qbCheckoutLabel=quickBuyModal?q('[data-pne-qb-checkout-label]',quickBuyModal):null;
  const qbNote=quickBuyModal?q('[data-pne-qb-note]',quickBuyModal):null;
  const qbDetails=quickBuyModal?q('[data-pne-qb-details]',quickBuyModal):null;

  const getQuickBuyRoot=()=>{
    const route=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return route.endsWith('/')?route:`${route}/`;
  };

  const pickInitialVariant=(data)=>{
    if(!data||!Array.isArray(data.variants)||!data.variants.length)return null;
    return data.variants.find(v=>v.available)||data.variants[0];
  };

  const updateQuickBuyState=()=>{
    if(!quickBuyModal||!quickBuyData)return;

    if(qbPrice){
      qbPrice.innerHTML=quickBuyVariant?formatShopMoney(quickBuyVariant.price):'';
      bucksReconvert();
    }

    const available=!!quickBuyVariant?.available;

    if(qbAvailability){
      qbAvailability.textContent=available?tr('available','Available'):tr('soldOut','Sold Out');
      qbAvailability.classList.toggle('is-sold',!available);
    }

    if(qbCheckout){
      qbCheckout.disabled=quickBuyRegion!=='quote'&&!available;
      qbCheckout.classList.toggle('is-quote',quickBuyRegion==='quote');
    }

    if(qbCheckoutLabel){
      if(quickBuyRegion==='quote') qbCheckoutLabel.textContent=tr('requestQuote','Request Shipping Quote');
      else if(!available) qbCheckoutLabel.textContent=tr('soldOut','Sold Out');
      else qbCheckoutLabel.textContent=quickBuyData.isPreorder?tr('reserveContinueCheckout','Reserve & Continue to Checkout'):tr('continueCheckout','Continue to Checkout');
    }

    if(qbNote){
      qbNote.textContent=quickBuyRegion==='quote'
        ? tr('noteQuote','Europe and other unlisted regions require shipping confirmation. WhatsApp will open with this product already included in the message.')
        : tr('noteDirect','You will continue directly to Shopify Checkout. Shipping and final totals can be reviewed before payment.');
    }
  };

  const buildQuickBuyOptions=(data)=>{
    if(!qbOptions)return;
    qbOptions.innerHTML='';

    if(data.hasOnlyDefaultVariant||!Array.isArray(data.options)||!data.options.length){
      qbOptions.hidden=true;
      return;
    }

    qbOptions.hidden=false;

    data.options.forEach((name,index)=>{
      const wrap=document.createElement('div');
      wrap.className='pne-qb-option';

      const label=document.createElement('label');
      label.textContent=name;

      const select=document.createElement('select');
      select.dataset.pneQbOption=String(index);
      select.setAttribute('aria-label',name);

      const values=[];
      (data.variants||[]).forEach(v=>{
        const value=v.options?.[index];
        if(value!=null&&!values.includes(value))values.push(value);
      });

      values.forEach(value=>{
        const option=document.createElement('option');
        option.value=value;
        option.textContent=value;
        if(quickBuyVariant?.options?.[index]===value)option.selected=true;
        select.appendChild(option);
      });

      select.addEventListener('change',()=>{
        const chosen=qa('[data-pne-qb-option]',qbOptions).map(s=>s.value);
        quickBuyVariant=(data.variants||[]).find(v=>v.options?.every((value,i)=>value===chosen[i]))||null;
        updateQuickBuyState();
      });

      wrap.append(label,select);
      qbOptions.appendChild(wrap);
    });
  };

  const openQuickBuy=(button)=>{
    if(!quickBuyModal||!button)return;

    const card=button.closest('[data-pne-product-card]');
    const dataEl=card?.querySelector('[data-pne-quick-buy-data]');
    if(!dataEl)return;

    try{
      quickBuyData=JSON.parse(dataEl.textContent);
    }catch(error){
      console.warn('PNE quick buy data error',error);
      return;
    }

    quickBuyVariant=pickInitialVariant(quickBuyData);
    quickBuyRegion='asia';
    quickBuyReturnFocus=button;

    if(qbTitle)qbTitle.textContent=quickBuyData.title||tr('product','Product');

    if(qbStatus){
      qbStatus.textContent=quickBuyData.status||(quickBuyData.isPreorder?'Pre-Order':'Private Inventory');
    }

    if(qbDetails)qbDetails.href=quickBuyData.url||'#';

    if(qbImage&&quickBuyData.image){
      qbImage.src=quickBuyData.image;
      qbImage.alt=quickBuyData.title||'';
      qbImage.hidden=false;
      if(qbImageEmpty)qbImageEmpty.hidden=true;
    }else{
      if(qbImage){
        qbImage.src='';
        qbImage.hidden=true;
      }
      if(qbImageEmpty)qbImageEmpty.hidden=false;
    }

    if(qbQty)qbQty.value='1';

    qa('[data-pne-qb-region]',quickBuyModal).forEach(region=>{
      region.classList.toggle('is-active',region.dataset.pneQbRegion==='asia');
    });

    buildQuickBuyOptions(quickBuyData);
    updateQuickBuyState();

    quickBuyModal.hidden=false;
    quickBuyModal.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('pne-quick-buy-open');
    document.body.classList.add('pne-quick-buy-open');

    requestAnimationFrame(()=>quickBuyModal.classList.add('is-open'));
    q('[data-pne-quick-buy-close]',quickBuyModal)?.focus({preventScroll:true});
  };

  const closeQuickBuy=()=>{
    if(!quickBuyModal||quickBuyModal.hidden)return;

    quickBuyModal.classList.remove('is-open');
    quickBuyModal.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('pne-quick-buy-open');
    document.body.classList.remove('pne-quick-buy-open');

    window.setTimeout(()=>{
      quickBuyModal.hidden=true;

      if(qbImage)qbImage.src='';

      if(quickBuyReturnFocus&&typeof quickBuyReturnFocus.focus==='function'){
        quickBuyReturnFocus.focus({preventScroll:true});
      }

      quickBuyData=null;
      quickBuyVariant=null;
    },180);
  };

  document.addEventListener('click',event=>{
    const buy=event.target.closest('[data-pne-quick-buy]');

    if(buy){
      event.preventDefault();
      event.stopPropagation();
      openQuickBuy(buy);
      return;
    }

    if(event.target.closest('[data-pne-quick-buy-close]')){
      event.preventDefault();
      closeQuickBuy();
    }
  });

  quickBuyModal?.addEventListener('click',event=>{
    const region=event.target.closest('[data-pne-qb-region]');

    if(region){
      quickBuyRegion=region.dataset.pneQbRegion||'asia';

      qa('[data-pne-qb-region]',quickBuyModal).forEach(item=>{
        item.classList.toggle('is-active',item===region);
      });

      updateQuickBuyState();
      return;
    }

    const checkout=event.target.closest('[data-pne-qb-checkout]');
    if(!checkout||!quickBuyData)return;

    if(quickBuyRegion==='quote'){
      window.open(quickBuyData.quoteUrl||window.PNE_QUOTE_URL||'#','_blank','noopener');
      return;
    }

    if(!quickBuyVariant?.available)return;

    const qty=Math.max(1,parseInt(qbQty?.value||'1',10)||1);
    checkout.disabled=true;

    if(qbCheckoutLabel)qbCheckoutLabel.textContent=tr('openingCheckout','Opening Secure Checkout…');

    window.location.href=`${getQuickBuyRoot()}cart/${quickBuyVariant.id}:${qty}`;
  });

  quickBuyModal?.addEventListener('keydown',event=>{
    if(event.key==='Escape'){
      event.preventDefault();
      closeQuickBuy();
    }
  });

})();


/* PNE CRITIC + VIRAL + REDTEAM V1 */
(function(){
  let busy=false;
  function sync(){
    if(busy)return;busy=true;
    try{
      const p=document.querySelector('[data-product-price]');
      const pm=document.querySelector('[data-pne-display-price-copy]');
      if(p&&pm){const n=p.textContent.trim();if(pm.textContent.trim()!==n)pm.textContent=n;}
      const q=document.querySelector('[data-pne-qb-price]');
      const qm=document.querySelector('[data-pne-qb-display-copy]');
      if(q&&qm){const n=q.textContent.trim();if(qm.textContent.trim()!==n)qm.textContent=n;}
    }finally{busy=false;}
  }
  document.addEventListener('DOMContentLoaded',function(){sync();setTimeout(sync,450);setTimeout(sync,1400);});
  new MutationObserver(sync).observe(document.documentElement,{subtree:true,childList:true,characterData:true});
})();


/* =========================================================
   PNE MOBILE STICKY PURCHASE DOCK V1
========================================================= */
(function(){
  const root = document.querySelector('[data-pne-mobile-purchase]');
  if(!root) return;

  const priceSource = document.querySelector('[data-product-price]');
  const priceTarget = root.querySelector('[data-pne-mobile-price]');
  const button = root.querySelector('[data-pne-mobile-buy]');
  const label = root.querySelector('[data-pne-mobile-buy-label]');
  const purchaseConsole = document.getElementById('PnePurchaseConsole');
  const isJa = (document.documentElement.lang || '').toLowerCase().startsWith('ja');

  function updateStatus(){
    const mode = (root.dataset.pnePurchaseMode || '').toLowerCase();
    const raw = (root.dataset.productStatus || '').toLowerCase();
    const available = root.dataset.productAvailable !== 'false';

    root.classList.remove('is-private','is-sold');

    if(!available || mode === 'sold' || raw.includes('sold')){
      root.classList.add('is-sold');
      return isJa ? '完売' : 'SOLD OUT';
    }

    if(mode === 'buy'){
      root.classList.add('is-private');
      return isJa ? '今すぐ購入' : 'BUY NOW';
    }

    /* Fallback only when Liquid did not classify the product. */
    if(
      !mode &&
      (
        raw.includes('private') ||
        raw.includes('in stock') ||
        raw.includes('available')
      )
    ){
      root.classList.add('is-private');
      return isJa ? '今すぐ購入' : 'BUY NOW';
    }

    return isJa ? '予約する' : 'RESERVE NOW';
  }

  function sync(){
    if(priceSource && priceTarget){
      const next = priceSource.textContent.trim();
      if(next && priceTarget.textContent.trim() !== next){
        priceTarget.textContent = next;
      }
    }

    if(label) label.textContent = updateStatus();

    if(button){
      const sold = root.classList.contains('is-sold');
      button.disabled = sold;
      button.setAttribute('aria-disabled', sold ? 'true' : 'false');
    }
  }

  if(button){
    button.addEventListener('click', function(){
      if(root.classList.contains('is-sold') || !purchaseConsole) return;

      purchaseConsole.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block:'start'
      });
    });
  }

  sync();
  setTimeout(sync,350);
  setTimeout(sync,1200);

  if(priceSource){
    const priceObserver = new MutationObserver(sync);
    priceObserver.observe(priceSource,{subtree:true,childList:true,characterData:true});
  }

  if(purchaseConsole && 'IntersectionObserver' in window){
    const observer = new IntersectionObserver(function(entries){
      const entry = entries[0];
      root.classList.toggle('is-hidden', entry.isIntersecting && entry.intersectionRatio > .16);
    },{threshold:[0,.16,.5]});
    observer.observe(purchaseConsole);
  }

  document.addEventListener('shopify:section:load', sync);
})();
